//CSS
import '../../Components/Page/Page.css';

//React

import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import Header2 from "../../Components/Header2/Header2";
import Footer from "../../Components/Footer/FooterSmall";
import { useUser } from '../../Context/UserContext';
import Espec from '../../Content/ESpec/ESpec';


const ProductsProtected: React.FC = () => {

    const { user, hasPermission } = useUser();

    const navigate = useNavigate();


    // if (!user) {
    //     return <div>User does not have permission</div>;
    // }

    useEffect(() => {
        // Redirect if not admin
        if (!user) { //hasPermission('products.Protected') will probably need to add this back
            navigate('/need-permission');
            return;
        }
    }, [user?.roles, navigate]);

    return (
        <div className='generalPage'>
            <Header2 />
            <div className='pageContainer'>
                <Espec />
                <div className="needPermission">
                    <h2>
                        More information coming soon
                    </h2>
                </div>
            </div>
            
            <Footer />
        </div>
    );
};

export default ProductsProtected;